// extracted by mini-css-extract-plugin
module.exports = {"padding":"Headline-module--padding--3vxxj"};